import { Loader2 } from 'lucide-react'

export function LoadingState({ label = 'Chargement…' }: { label?: string }) {
  return (
    <div
      role="status"
      aria-busy="true"
      aria-label={label}
      className="flex min-h-[45vh] flex-col items-center justify-center gap-4 px-4"
    >
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-card shadow-ref-soft ring-1 ring-border/80">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" aria-hidden />
      </div>
      <p className="text-sm font-medium text-muted-foreground">{label}</p>
    </div>
  )
}
